import { Component, Input } from "@angular/core";
import { FormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { User } from "@sentry/angular";
import { Subject, takeUntil } from "rxjs";
import { AuthService } from "src/app/api/auth.service";
import { ProfileService } from "src/app/api/profile.service";
import { SupportService } from "src/app/api/support.service";
import {
  EscalationInput,
  SupportCategory,
  SupportInput,
} from "src/app/models/support";
import { EscalationType } from "src/app/models/support";
import { HCaptchaService } from "src/app/services/hcaptcha.service";
import { LocaleService } from "src/app/services/locale.service";
import { CustomValidators } from "src/app/validators/custom-validators";

@Component({
  selector: "escalation-ticket",
  templateUrl: "./escalation-ticket.component.html",
  styleUrl: "./escalation-ticket.component.scss",
})
export class EscalationTicketComponent {
  EscalationType = EscalationType;
  private destroy$ = new Subject<void>();

  loading = false;
  loadingCaptcha = false;
  error: string = null;
  success = false;

  form = this.fb.group({
    escalationType: [null, Validators.required],
    email: [
      { value: null, disabled: this.isLoggedIn() },
      [Validators.required, CustomValidators.emailValidator],
    ],
    ticketId: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
    description: [null, Validators.required],
  });

  user: User;

  constructor(
    private localeService: LocaleService,
    private fb: UntypedFormBuilder,
    private profileSerivce: ProfileService,
    private supportService: SupportService,
    private hCaptchaService: HCaptchaService,
    private auth: AuthService,
    private route: ActivatedRoute
  ) {}
  ngOnInit() {
    this.profileSerivce
      .get()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: User) => {
          this.user = response;
          this.email.setValue(this.user.email);
        },
        (err) => {}
      );
  }

  resetForm() {
    this.form.reset();
    if (this.isLoggedIn()) {
      this.email.setValue(this.user.email);
    } else this.email.reset();
  }

  onSubmit() {
    this.success = false;
    this.error = null;
    if (this.form.valid) {
      let payload: EscalationInput = {
        email: this.email.value,
        ticketID: Number(this.ticketId.value),
        description: this.description.value,
        escalationType: this.escalationType.value,
      };
      {
        this.sendTicket(payload);
      }
    } else {
      this.form.markAllAsTouched();
      if (this.localeService.isArabic())
        this.error = "الرجاء تعبئة كافة الحقول المطلوبة.";
      else this.error = "Please fill out the required fields";
      this.scrollToTop();
    }
  }

  async sendTicket(payload: EscalationInput) {
    this.loading = true;
    let captcha: string = "";

    if (this.hCaptchaService.isCaptchaEnabled) {
      this.loadingCaptcha = true;

      try {
        captcha = await this.hCaptchaService.getCaptcha();
      } catch (err) {
        console.log("hcaptcha_ERROR", err);
        return;
      } finally {
        this.loadingCaptcha = false;
      }
    }

    this.supportService
      .sendEscalationTicket(payload, captcha)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          //TODO:test response
          this.loading = false;
          this.success = true;
          this.scrollToTop();
          this.resetForm();
        },
        (err) => {
          this.loading = false;
          this.error =
            err?.errors?.[0]?.message || err?.error?.error_description;

          this.scrollToTop();
          this.resetForm();
        }
      );
  }

  scrollToTop() {
    window.scroll(0, 0);
  }
  isLoggedIn(): boolean {
    if (this.auth.getToken()) return true;
    return false;
  }

  get email() {
    return this.form.get("email");
  }
  get escalationType() {
    return this.form.get("escalationType");
  }
  get description() {
    return this.form.get("description");
  }
  get ticketId() {
    return this.form.get("ticketId") as FormGroup;
  }




    ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
